import { cloneConfig, validateOfferEditor } from './commonEditorModel';
import { numberFromInput, serializeSharedProductFields } from './editorProductFields';

export const validateHomePhoneEditor = (values = {}) => validateOfferEditor(values, {
    priceFields: ['price', 'regularPrice', 'requiredFees']
});

export const serializeHomePhoneEditor = (sourceConfig, editor, archivedAt) => {
    const nextConfig = cloneConfig(sourceConfig);
    const group = nextConfig.products.homePhone[editor.groupName] || [];
    const index = group.findIndex((product) => product.id === editor.originalId);
    if (index === -1 && !editor.isNew) {
        throw new Error('Unable to find the selected Home Phone product in the draft config.');
    }

    const values = editor.values;
    const previous = index === -1 ? {} : group[index];
    const nextProduct = {
        ...previous,
        id: editor.originalId,
        displayName: values.displayName.trim(),
        price: numberFromInput(values.price),
        regularPrice: values.regularPrice === '' ? undefined : numberFromInput(values.regularPrice),
        requiredFees: values.requiredFees === '' ? undefined : numberFromInput(values.requiredFees),
        ...serializeSharedProductFields(values, previous, archivedAt)
    };

    if (index === -1) {
        group.push(nextProduct);
    } else {
        group[index] = nextProduct;
    }
    nextConfig.products.homePhone[editor.groupName] = group;
    return nextConfig;
};
